import { render, staticRenderFns } from "./RegisterMedicine.html?vue&type=template&id=bcbf27e2&external"
import script from "./RegisterMedicine.vue?vue&type=script&lang=js"
export * from "./RegisterMedicine.vue?vue&type=script&lang=js"
import style0 from "./RegisterMedicine.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports